import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
  staffClaimApplications,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
  staffClaimApplicationsColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

function StaffClaimsTable() {
  const base_url = HRService.uri;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const UserId = parseInt(decodedToken.Id);

  const actions = {
    entity: " Staff Claim Approvals",

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

  ApproveStaffClaim: {
    key: "APPROVE_LEAVE",
    button_name: "Approve/Reject Staff Claim",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  decline: {
    key: "REJECT_LEAVE",
    button_name: "Reject Staff Claim",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },

    dataObject: {
      objectName: "staffClaimApprovalsByApplication",
      inputObjectName: "staffClaim",
      parameters: { userId: UserId },
    },
    actionName: " Staff Claim ",
    showStatus: true,
  };
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Staff Claims"
          subtitle="View all Staff Claims, approve or decline"
          columns={staffClaimApplicationsColumns}
          // query={staffClaimApplications}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default StaffClaimsTable;
